import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { AnnualLabourAttendanceMonitoringAverageReport } from './Pages/listing';

export const AnnualLabourAttendanceMonitoringAverageReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={AnnualLabourAttendanceMonitoringAverageReport} />
    </Fragment>
)